var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connect-wallet font-color__theme border-color display-flex__align-center"},[(!_vm.wallet)?_c('span',{on:{"click":_vm.connectWallet}},[_vm._v(_vm._s(_vm.$t('head.connect')))]):_c('span',{on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.walletAddress)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }